import { patientBffApi } from '@/modules/baseApi';
import { SurgicalEventService } from './surgicalEvent.service';
import {
  AnesthesiaRisk,
  SurgeryInfo,
  SurgicalEvent,
  UpcomingSurgery
} from './surgicalEvent.model';
import { unwrapApiErrorDetails } from '@ianesthesie-kit/services';
import { wrapError } from '@/util';
import { MedicalDocument } from '@/modules/document';

export const surgicalEventApi = patientBffApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    activeSurgicalEvent: builder.query<SurgicalEvent, void>({
      providesTags: ['ActiveSurgicalEvent'],
      queryFn: () =>
        SurgicalEventService.getInstance()
          .fetchActive()
          .then((r) => ({
            data: r.data
          }))
          .catch((err) => ({
            error: unwrapApiErrorDetails(err) || err
          }))
    }),

    activeSurgeryInfo: builder.query<SurgeryInfo, void>({
      queryFn: () =>
        SurgicalEventService.getInstance()
          .fetchActiveSurgeryInfo()
          .then((r) => ({
            data: r.data
          }))
          .catch(wrapError),
      providesTags: ['SurgeryInfo', 'ActiveSurgicalEvent']
    }),

    activeFollowUpPlans: builder.query<UpcomingSurgery[], void>({
      queryFn: () =>
        SurgicalEventService.getInstance()
          .fetchActiveFollowUpPlans()
          .then((r) => ({
            data: r.data
          }))
          .catch(wrapError),
      providesTags: ['FollowUpPlans', 'ActiveSurgicalEvent']
    }),

    activeAnesthesiaRisk: builder.query<AnesthesiaRisk, void>({
      queryFn: () =>
        SurgicalEventService.getInstance()
          .fetchActiveAnesthesiaRisks()
          .then((r) => ({
            data: r.data
          }))
          .catch(wrapError),
      providesTags: ['AnesthesiaRisk', 'ActiveSurgicalEvent']
    }),

    markPrescriptionAsViewed: builder.mutation<unknown, MedicalDocument>({
      queryFn: (medicalDocument) =>
        SurgicalEventService.getInstance()
          .markPrescriptionAsViewed(medicalDocument)
          .then(() => ({ data: {} }))
          .catch(wrapError)
    })
  })
});

export const {
  useActiveSurgicalEventQuery: useActiveSurgicalEvent,
  useActiveSurgeryInfoQuery: useActiveSurgeryInfo,
  useActiveFollowUpPlansQuery: useActiveFollowUpPlans,
  useActiveAnesthesiaRiskQuery: useActiveAnesthesiaRisk,
  useMarkPrescriptionAsViewedMutation: useMarkPrescriptionAsViewed
} = surgicalEventApi;
